import { FormControl } from "@angular/forms";
import moment from "moment";

export const MomentDobValidator = (control: FormControl): any => {
	if (control?.value) {
		const dob = moment(control.value, "DD/MM/YYYY");
		const age = moment().diff(dob, "years") || 0;
		const dateRegex = /^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/g;
		const isDateRegex = dateRegex.test(control.value);
		const todayDate = moment();
		if (!isDateRegex) {
			return setError("Date should be in DD/MM/YYYY format");
		} else if (!todayDate.isAfter(dob)) {
			const msg = dob.isValid()
				? "Future date is not allowed"
				: "Date is not valid";
			return setError(msg);
		} else if (age < 18) {
			return setError("Age should 18+");
		} else if (age > 130) {
			return setError("Age should not be more than 130");
		}
		return null;
	}
	return null;
};

const setError = (message: string) => ({
	dateOfBirthInvalid: {
		valid: false,
		message,
	},
});
